import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

import appConfig from '../../config/app.json';

export const BrandHub = styled.section`
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.secondary.main} 0%,
    ${({ theme }) => theme.base.black} 56.25%
  );
  padding: 22px 0 16px 0;
  z-index: 12;
  position: sticky;
  top: ${appConfig.layout.hubHeight}px;

  ${breakpoints.md} {
    top: ${appConfig.layout.hubHeightMd}px;
  }
  ${breakpoints.lg} {
    padding: 24px 0;
  }
`;

export const HubBody = styled.div`
  display: grid;
  gap 0 16px;
  & > div {
    gap 0 16px;
  }
  ${breakpoints.lg} {
    & > div {
      gap: 0 32px;
    }
    gap: 0 32px;
  }
`;

export const BrandContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-column: 1/13;
  margin-top: -8px;
  button {
    align-self: center;
  }
  ${breakpoints.lg} {
    grid-column: 1/3;
    margin-top: 0;
  }
`;

export const BrandWrapper = styled.div`
  display: flex;
  gap: 16px;
  min-height: 48px;
  align-items: center;
`;

export const BrandDescription = styled.div`
  color: ${({ theme }) => theme.base.white};
  margin-left: 64px;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.3rem;
  max-width: 850px;
  grid-column: 1/ 13;
  align-self: center;

  ${breakpoints.lg} {
    margin-left: 0;
    grid-column: 3/ 13;
  }

  &.hide-mobile {
    display: none;

    ${breakpoints.lg} {
      display: inherit;
    }
  }
  &.no-image {
    margin-left: 0;
  }
`;

export const BrandTitle = styled.a`
  color: ${({ theme }) => theme.base.white};
  font-weight: 800;
  font-size: 1.3rem;
  line-height: 1.5rem;
  margin-bottom: 8px;
  ${breakpoints.lg} {
    margin-bottom: 0;
  }
`;

export const BrandImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
`;

export const Circle = styled.a`
  display: block;
  position: relative;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.base.white};
  flex-shrink: 0;
  cursor: ${({ avatar }) => (avatar ? 'initial' : 'pointer')};

  img {
    width: 100%;
    height: auto;
  }
`;

export const TitleWrapper = styled.div`
  min-height: 48px;
  padding-top: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  ${breakpoints.lg} {
    padding-top: 0;
  }
`;
